<template>
  <form @submit.prevent="onSubmit"
        class="auth-agent-login">
    <BasePreloader v-if="pending"/>

    <h1 class="auth-agent-login__title">{{ $tAuthAgentLogin('title') }}</h1>
    <div class="auth-agent-login__inputs">
      <BaseInput v-model="inputs.login.value"
                 :error="inputs.login.error"
                 :label="$tAuthAgentLogin('input_login')"
                 name="agent-login"
                 autocomplete="agent-login"
                 class="auth-agent-login__input"/>
      <BaseInput v-model="inputs.password.value"
                 :error="inputs.password.error"
                 :label="$tAuthAgentLogin('input_password')"
                 type="password"
                 name="agent-password"
                 autocomplete="agent-password"
                 class="auth-agent-login__input"/>

      <div class="auth-agent-login__forgot-password-wrap _forgot-agent">
        <a  @click.prevent="$vModal.open('forgot-pass-agent', {defaultEmailPhone: inputs.login.value})">
          {{ $tAuthAgentLogin('forgot_password') }}
        </a>
      </div>
    </div>
    <BaseAlert :value="overallErrorsMix"
               class="auth-agent-login__error  _warning"/>
    <div class="auth-agent-login__submit">
      <button type="submit"
              class="auth-agent-login__btn  base-btn  base-btn--blue">
        {{ $tAuthAgentLogin('btn_login') }}
      </button>

    </div>
  </form>
</template>

<script>
  import formMixins from '@/mixins/formMixins'
  import {mapActions} from 'vuex'

  export default {
    name: 'AuthAgentLogin',
    mixins: [formMixins],
    data() {
      return {
        pending: false,
        forgotModal: false,
        inputs: {
          login: {
            value: null
          },
          password: {
            value: null
          }
        }
      }
    },
    methods: {
      ...mapActions('user', [
        'loginAgent'
      ]),
      forgotPassword() {
        this.forgotModal = true
      },
      onSubmit() {
        this.pending = true

        this.resetErrorsMix(this.inputs)
        const sendData = this.createSendDataMix(this.inputs)

        this.loginAgent({sendData})
          .then(() => {
            this.$router.push({name: 'account-agent-resumes-base'})
              .catch(() => ({}))
          })
          .catch(e => {
            this.errorHandlerMix(e, this.inputs)
          })
          .finally(() => {
            this.pending = false
          })
      }
    }
  }
</script>

<style lang="less">

</style>
